import React, { useRef } from 'react'

import { getRenderer } from 'models/refStore/selectors'

require('./DirectInteractionLayer.scss')

const DirectInteractionLayer = () => {
    const layerRef = useRef(null)

    const renderer = getRenderer()

    const transformCoords = (e) => {
        // Returns [x, y] fractional coordinates (range 0 - 1.0)
        const corner = layerRef.current
        const { clientX, clientY } = e
        const { left, top, width, height } = corner.getBoundingClientRect()

        const eventX = clientX - left
        const eventY = clientY - top

        return [eventX / width, eventY / height]
    }

    const onMouseMove = (e) => {
        // console.debug(transformCoords(e))
        if (renderer) {
            renderer.onMouseMove(transformCoords(e))
        }
    }

    const onClick = (e) => {
        // console.debug(transformCoords(e))
        if (renderer) {
            renderer.onClick(transformCoords(e))
        }
    }

    return <div ref={layerRef} onMouseMove={onMouseMove} onClick={onClick} className="DirectInteractionLayer" />
}

DirectInteractionLayer.defaultProps = {}

DirectInteractionLayer.propTypes = {}

export default DirectInteractionLayer
